// extracted by mini-css-extract-plugin
module.exports = {"floatBtnContent":"dp-5OROo88v","content":"dp-VsPrRiFm","title":"dp-OTlODFCw","desc":"dp-02EICffi","signUpBtn":"dp-69c40i7W"};